import _ from 'lodash-es';
import kformUtils from '../../utils/kform-utils';
import { replaceBulk } from '~/utils/string';
import $ from 'jquery';

// dd/MM/yyyy => d/m/Y
const convertFormat = (/** @type {any} */ format) => replaceBulk(
	format,
	// eslint-disable-next-line no-multi-spaces
	['dd', 'MM', 'yyyy', 'HH', 'mm', 'ss'],
	// eslint-disable-next-line no-multi-spaces
	['d',  'm',  'Y',    'H',  'i',  's'],
);

export default /* @ngInject */ (
	/** @type {any} */ $scope,
	/** @type {import('angular').ITimeoutService} */ $timeout,
) => {
	$timeout(() => {
		if ($scope.$$childTail) {
			$scope.index = $scope.$$childTail.index;
		}
	})
	// Watch for changes to the meridian settings to synchronize the submissionGrid and component view.
	// $scope.$watch('component.timePicker.showMeridian', update => {
	// 	// Remove any meridian reference, because were not in 12 hr.
	// 	if (!$scope.component.enableTime || !update) {
	// 		$scope.component.format = $scope.component.format.replace(/ a/, '');
	// 		return;
	// 	}
	//
	// 	// If we're missing the meridian string and were in 12 hr, add it.
	// 	if (update && !$scope.component.format.includes(' a')) {
	// 		$scope.component.format += ' a';
	// 	}
	// });

	// $scope.$watch('component.datePicker.showWeeks', showWeekds => {
	// 	$scope.fpOptions.weekNumbers = showWeekds;
	// });
	//
	// $scope.$watch('component.datePicker.startingDay', startingDay => {
	// 	$scope.fpOptions.startingDay = startingDay;
	// });

	if ($scope.data && !Array.isArray($scope.data[$scope.component.key])) {
		$scope.data[$scope.component.key] = [];
	}

	$scope.component.datePicker.minDate = kformUtils.getDateSetting(_.get($scope.component, 'datePicker.minDate'));
	$scope.component.datePicker.maxDate = kformUtils.getDateSetting(_.get($scope.component, 'datePicker.maxDate'));

	$scope.autoOpen = true;
	$scope.onClosed = () => {
		$scope.autoOpen = false;
		$timeout(() => {
			$scope.autoOpen = true;
		}, 250);
	};

	$scope.changeValue = () => {
		if ($scope.data) {
			// if date changes then removes kid
			$scope.data[$scope.component.key][$scope.index].kid = undefined;

			// trigger change event
			$(`#${$scope.component.key}`)
				.trigger('change');
			if (typeof $scope.component.event.onChange === 'string') {
				const custom = ''.concat($scope.component.event.onChange, '; ');
				kformUtils.evaluate(custom, {
					data: $scope.data,
					form: $scope.form,
				});
			}
		}
	};

	$scope.fpOptions = {
		allowInfinity: $scope.component.allowInfinity,
		allowInput:    true,
		allowSetNow:   true,
		altFormat:     convertFormat($scope.component.format),
		closeOnScroll: true,
		displayInput:  true,
		enableTime:    $scope.component.enableTime,
		defaultDate:   $scope.component.defaultDate,
		placeholder:   $scope.component.placeholder,
		time_24hr:     !$scope.component.timePicker.showMeridian,
		weekNumbers:   $scope.component.showWeeks,
	};
}